import React, { useEffect, useState } from 'react'
import Div100vh from 'react-div-100vh'
import {useLocation} from 'react-router-dom';
import {baseUrl} from '../../services/httpSvc';
// import ObjViewer from '../../components/ObjViewer'
import ThreejsObjViewer from '../../components/ThreejsObjViewer'

import './Viewer.scss'

const Viewer = () => {
  const {search} = useLocation()
  const [id, setId] = useState(null)
  const [token, setToken] = useState(null)
  const [model, setModel] = useState(null)

  useEffect(() => {
    localStorage.setItem('accessToken', token)
  }, [token])

  useEffect(() => {
    if (id && token && localStorage.getItem('accessToken')) {
      const m = {
        token,
        obj: `${baseUrl}meshes/${id}.obj`,
        mtl: `${baseUrl}meshes/${id}.mtl`,
      };
      setModel(m)
    }
  }, [id, token])

  useEffect(() => {
    if (search) {
      const p = new URLSearchParams(search)
      const i = p.get('id')
      const t = p.get('token')
      setId(i)
      setToken(t)
    }
  }, [search])

  return (
    <Div100vh className="viewer" style={{backgroundColor: 'transparent'}}>
      {!!model && <ThreejsObjViewer model={model} style={{width: '100%'}}/>}
    </Div100vh>
  )
}

export default Viewer